/**
 * Note: UNKNOWN doesn't actually exist in the BE, so we have to map it to OTHER when sending it
 */

export const OTHER_COLOR_ID = -1;
export const BLANK_COLOR_ID = 1;
export const UNKNOWN_COLOR_ID = -2;

export const OTHER_PRODUCER_COLOR_CODE = 'other';
export const UNKNOWN_PRODUCER_COLOR_CODE = 'unknown';
export const DEFAULT_PRODUCER_COLOR_CODE = 'DEFAULT';

export const SMALL_LOT = 'small-lot';

/** Prefixes used to namespace keys in the unified RadioCardGroup in OrderNowV2Selector. */
export const CALL_OFF_RADIO_PREFIX = 'call-off';
export const QUOTE_RADIO_PREFIX = 'quote';
